// 时间格式化
export function dataFormat(fmt,date){
  const o = {
    "M+" : date.getMonth()+1,                 //月份
    "d+" : date.getDate(),                    //日
    "h+" : date.getHours(),                   //小时
    "m+" : date.getMinutes(),                 //分
    "s+" : date.getSeconds(),                 //秒
    "q+" : Math.floor((date.getMonth()+3)/3), //季度
    "S"  : date.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(let k in o)
    if(new RegExp("("+ k +")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}

// 格式时间yyyyMMddhhmmss
export function formatStrDotyyyyMMddhhmmss(timeLong) {
  if (!timeLong){
    return "";
  }
  let data = new Date(timeLong);
  return dataFormat("yyyyMMddhhmmss", data);
}

// 获取时间
export function formatStrDotyyyyMMddhhmm(timeLong) {
  if (!timeLong){
    return "";
  }
  let data = new Date(timeLong);
  return dataFormat("yyyy.MM.dd hh:mm", data);
}

/**
 * 格式化查看时间 yyyy-MM-dd hh:mm
 * @param timeLong
 * @returns {string}
 */
export function viewTimeFormat(timeLong) {
  const nowYear =  new Date().getFullYear();
  const timestamp = new Date().getTime();
  if((timestamp - timeLong) <= 60000){
    return "刚刚"
  }
  let rt = "—";
  if (timeLong > 0) {
    try {
      rt =  formatStr_yyyyMMddhhmm(timeLong);
      if (rt.indexOf(nowYear) == 0) {
        return rt.substring(5);
      }
    } catch(t) {
      console.error(t);
    }
  }
  return rt;
}
export function formatStr_yyyyMMddhhmm(timeLong) {
  if (!timeLong){
    return "";
  }
  let data = new Date(timeLong);
  return dataFormat("yyyy-MM-dd hh:mm", data);
}
export function formatStr_MMddhhmm(timeLong) {
  if (!timeLong){
    return "";
  }
  let data = new Date(timeLong);
  return dataFormat("MM-dd hh:mm", data);
}
/**
 * 格式化查看时间 yyyy.MM.dd
 * @param timeLong
 * @returns {string}
 */
export function formatStrDotyyyyMMdd(timeLong) {
  if (!timeLong){
    return "";
  }
  let data = new Date(timeLong);
  return dataFormat("yyyy.MM.dd", data);
}
export function stringToDate (dateString) {
  if (!dateString) {
    return "";
  }
  const dateStr = dateString.replace(/-/g, "/");
  return new Date(dateStr);
}

/**
 * 阅读时长 xxxhourxxminxxs
 * @param value
 * @returns {string}
 */
export function learnTimeFormat(value) {
  let rt = "—";
  if (value && value > 0) {
    let hour = "", min = "", sec = "";
    if (value >= 3600) {
      let num = parseInt(value / 3600) ;
      value = value - num * 3600;
      hour = num + "hour";
    }
    if (value >= 60) {
      min = (parseFloat(value / 60).toFixed(0)) + "min";
    }
    rt = hour + min;
    if (rt == "") {
      sec = value % 60;
      //四舍五入
      sec = (sec > 0  ? (Math.round(sec) + "s") : "");
      rt = sec;
    }
  }
  return rt;
}